import { NavItem } from '@palmetto/dsm-components';
import featureConfig, { IFeatureConfig } from '../../config/featureConfig';

import { ROUTE } from '../../routes';

interface NavItemConfig {
  path: string;
  matchPaths?: string[];
  iconName: NavItem['iconName'];
  featureConfig?: IFeatureConfig;
}

const navConfig: Record<string, NavItemConfig> = {
  home: {
    path: ROUTE.HOME,
    matchPaths: [ROUTE.HOME, ROUTE.ELECTRICITY_USAGE, ROUTE.SOLAR],
    iconName: 'home',
    featureConfig: featureConfig.displayHomePage,
  },
  shop: {
    path: ROUTE.SHOP,
    iconName: 'shoppingCart',
  },
  energyProfile: {
    path: ROUTE.ENERGY_PROFILE,
    iconName: 'homeElectricityBolt',
  },
  billing: {
    path: ROUTE.FINANCE_ACCOUNTS,
    iconName: 'moneyDollarSignBillingCircleArrow',
    featureConfig: featureConfig.financeAccountDetail,
  },
  account: {
    path: ROUTE.ACCOUNT,
    matchPaths: [ROUTE.ACCOUNT, ROUTE.PROFILE, ROUTE.REFER, ROUTE.CONNECTED_ACCOUNTS],
    iconName: 'userCircle',
  },
  energy: {
    path: ROUTE.ENERGY,
    matchPaths: [ROUTE.ENERGY, ROUTE.ACHIEVEMENTS],
    iconName: 'bolt',
    featureConfig: featureConfig.energyPage,
  },
  learn: {
    path: ROUTE.LEARNING_CENTER,
    matchPaths: [ROUTE.LEARNING_CENTER, ROUTE.LEARNING_CENTER_ARTICLE, ROUTE.LEARNING_CENTER_CATEGORY],
    iconName: 'bookRead',
  },
  service: {
    path: ROUTE.SERVICE,
    iconName: 'toolsService',
    featureConfig: featureConfig.service,
  },
  support: {
    path: ROUTE.SUPPORT,
    iconName: 'chatSupport',
  },
  plaidDemo: {
    path: ROUTE.PLAID_DEMO,
    iconName: 'moneyDollarSignBillingCircleArrow',
    featureConfig: featureConfig.plaidDemo,
  },
};

const bottomNav: (keyof typeof navConfig)[] = ['home', 'energy', 'learn', 'shop'];
const sideNavTop: (keyof typeof navConfig)[] = ['home', 'energy', 'service', 'support', 'learn', 'shop', 'billing'];
const sideNavBottom: (keyof typeof navConfig)[] = ['account'];

export { bottomNav, navConfig, sideNavBottom, sideNavTop };
